import { DownOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, Tooltip } from 'antd';
import { cloneElement, useCallback, useMemo } from 'react';

import type { PaymentButtonType } from '@app/components/RecordModal/components/RecordPayment/types';

import type { MenuProps } from 'antd';
import type { ReactElement, ReactNode } from 'react';

const { Button } = Dropdown;

type GetButtonsRenderType = (buttons: ReactNode[]) => ReactNode[];

export const PaymentButton: PaymentButtonType = ({
  disabled,
  overlayClassName,
  className,
  options,
  onSelectMenuItem,
  selectedPaymentMethod,
  handleOptionClick,
  tooltipTitle,
  icon,
  iconClassName,
  title,
  description,
  testId,
  dropdownTestId,
}) => {
  const menu: MenuProps = useMemo(
    () => ({
      items: options.map((option, index) => ({
        ...option,
        key: option.key || index,
        label: <span data-testid="dropdown-list-item">{option.label}</span>,
      })),
      className: 'dropdown-list-payment',
      onClick: ({ key }) => onSelectMenuItem(key),
    }),
    [options, onSelectMenuItem]
  );

  const onClick = useCallback(() => {
    const handledSelected = selectedPaymentMethod
      ? { ...selectedPaymentMethod, Id: selectedPaymentMethod?.Id }
      : null;

    handleOptionClick(handledSelected);
  }, [handleOptionClick, selectedPaymentMethod]);

  const getButtonsRender: GetButtonsRenderType = useCallback(
    ([leftButton, rightButton]) => {
      const showTooltip = !!selectedPaymentMethod?.Name;
      return [
        <Tooltip
          title={showTooltip ? tooltipTitle : ''}
          key={`${dropdownTestId}-tooltip`}
        >
          <div data-testid={testId}>{leftButton}</div>
        </Tooltip>,
        cloneElement(
          rightButton as ReactElement<
            { loading: boolean; 'data-testid': string },
            string
          >,
          {
            loading: false,
            key: dropdownTestId,
            'data-testid': dropdownTestId,
          }
        ),
      ];
    },
    [selectedPaymentMethod, tooltipTitle, testId, dropdownTestId]
  );

  return (
    <Button
      disabled={disabled}
      overlayClassName={overlayClassName}
      className={className}
      icon={<DownOutlined />}
      menu={menu}
      onClick={onClick}
      buttonsRender={getButtonsRender}
    >
      <div className="payment-receipt payment-component__buttons">
        <FontAwesomeIcon
          className={`${iconClassName} button-icon`}
          icon={icon}
        />
        <div>
          <p className="receipt-title">{title}</p>
          <p className="receipt-description">{description}</p>
        </div>
      </div>
    </Button>
  );
};
